/*分页设置*/
export const paginations = {
  // current: 1,
  page: 1,
  limit:10,
  pageSizes: [10, 100, 200, 300, 500],
  pageSizesOption: ['10', '100', '200', '300', '500'],
  total: 0,
};
